module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-styled-components@6.15.0_babel-plugin-styled-components@2.3.0_@babel+core_73acef3f6b0677bb8d6cb11afed216bd/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":false,"disableVendorPrefixes":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.15.0_@babel+plugin-syntax-flow@7.23.3_@babel+core@7.29.6__@babel+plugin-transf_830b5d21146b80dd65a3329ebf64251b/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
